// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  position: fixed;
  top: 0;
  left: 75px;
  height: 100%;
  width: calc(100% - 75px);
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
}

.login-form-container {
  height: 100%;
  width: 55%;
}

.login-banner-container {
  height: 100%;
  width: 45%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".login-page {\n  position: fixed;\n  top: 0;\n  left: 75px;\n  height: 100%;\n  width: calc(100% - 75px);\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-form-container {\n  height: 100%;\n  width: 55%;\n}\n\n.login-banner-container {\n  height: 100%;\n  width: 45%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
